export default __webpack_public_path__ + "static/media/main-slide-img1.1f415d19.png";